export const TEMPLATE_DETAIL_CONTENT = {
  recruiters: {
    badge: {
      ru: "🤖 Шаблон для рекрутинга и HR",
      en: "🤖 Template for Recruiting and HR",
    },
    title: {
      ru: "AI-ассистент для найма\nОбщается с кандидатами 24/7",
      en: "AI assistant for hiring\nCommunicates with candidates 24/7",
    },
    description: {
      ru: "Отвечает на вопросы о вакансиях, проводит скрининг, записывает на собеседования. Экономит 10+ часов рекрутера в неделю.",
      en: "Answers questions about vacancies, conducts screening, and schedules interviews. Saves recruiters 10+ hours per week.",
    },
    stats: {
      ru: "⚡ 3 минуты на настройку · Бесплатно · Без привязки карты",
      en: "⚡ 3 minutes to set up · Free · No card required",
    },
    audienceTitle: {
      ru: "Кому и зачем нужен этот шаблон",
      en: "Who this template is for and why it matters",
    },
    audienceDescription: {
      ru: "Цифровой помощник рекрутера — для компаний, которые хотят нанимать быстрее, качественнее и без лишних затрат.",
      en: "A digital recruiting assistant for companies that want to hire faster, better, and with fewer costs.",
    },
    features: [
      {
        emoji: "🗣️",
        title: { ru: "Мгновенные ответы 24/7", en: "Instant replies 24/7" },
        description: {
          ru: "Кандидат получает ответ о зарплате, графике или офисе в любое время — даже ночью.",
          en: "Candidates get answers about salary, schedule, or office at any time, even at night.",
        },
      },
      {
        emoji: "📝",
        title: { ru: "Первичный скрининг", en: "Initial screening" },
        description: {
          ru: "Задаёт ключевые вопросы, отсеивает неподходящих кандидатов до разговора с рекрутером.",
          en: "Asks key questions and filters out unsuitable candidates before a recruiter joins.",
        },
      },
      {
        emoji: "📅",
        title: { ru: "Запись в календарь", en: "Calendar scheduling" },
        description: {
          ru: "Интеграция с Google/Outlook: кандидат сам выбирает слот, собеседование создаётся автоматически.",
          en: "Integrates with Google/Outlook: the candidate picks a slot and the interview is created automatically.",
        },
      },
      {
        emoji: "📊",
        title: { ru: "Сбор данных в CRM", en: "CRM data capture" },
        description: {
          ru: "Имя, контакты, опыт, ожидания — всё уходит в вашу ATS или по вебхуку.",
          en: "Name, contacts, experience, and expectations go straight to your ATS or webhook.",
        },
      },
      {
        emoji: "🔔",
        title: { ru: "Эскалация рекрутеру", en: "Recruiter escalation" },
        description: {
          ru: "Если кандидат «горячий» — ассистент зовёт оператора в чат с полной историей.",
          en: "If a candidate is highly interested, the assistant invites a recruiter into the chat with full context.",
        },
      },
      {
        emoji: "🧠",
        title: { ru: "Единый бренд общения", en: "Consistent brand voice" },
        description: {
          ru: "Всегда следует скриптам и описаниям вакансий — никакой импровизации.",
          en: "Always follows scripts and vacancy descriptions, with no improvisation.",
        },
      },
    ],
    problemTitle: { ru: "❌ Проблемы без AI", en: "❌ Problems without AI" },
    problems: [
      {
        ru: "Рекрутеры тратят 70% времени на вопросы «сколько платят?» и «где офис?»",
        en: "Recruiters spend 70% of their time answering questions like “what is the salary?” and “where is the office?”",
      },
      {
        ru: "Кандидаты уходят к конкурентам, потому что не дождались ответа в нерабочее время",
        en: "Candidates go to competitors because they did not get a reply outside business hours.",
      },
      {
        ru: "Долгий наём: пока рекрутер освободится, кандидат уже находит другую работу",
        en: "Hiring takes too long: by the time the recruiter is free, the candidate has already found another job.",
      },
      {
        ru: "Разные рекрутеры по-разному описывают условия — страдает HR-бренд",
        en: "Different recruiters describe conditions differently, which hurts the employer brand.",
      },
    ],
    solutionTitle: { ru: "✅ Решения с Supchats", en: "✅ Solutions with Supchats" },
    solutions: [
      {
        ru: "AI отвечает на типовые вопросы моментально — рекрутеры занимаются только финалами",
        en: "AI answers routine questions instantly, so recruiters focus only on final-stage conversations.",
      },
      {
        ru: "Ассистент работает 24/7: ни одна заявка не теряется, даже в 3 часа ночи",
        en: "The assistant works 24/7, so no application is lost, even at 3 AM.",
      },
      {
        ru: "Скорость реакции — секунды. Кандидат сразу попадает в воронку найма",
        en: "Response time is measured in seconds, so the candidate immediately enters the hiring funnel.",
      },
      {
        ru: "Единые скрипты и база знаний — каждый кандидат слышит одно и то же",
        en: "Unified scripts and a shared knowledge base ensure every candidate gets the same message.",
      },
    ],
    comparisonTitle: {
      ru: "AI-ассистент против обычного рекрутера на первом этапе",
      en: "AI assistant vs a regular recruiter at the first stage",
    },
    comparisonHeaders: {
      feature: { ru: "Характеристика", en: "Characteristic" },
      ai: { ru: "AI-ассистент (наш шаблон)", en: "AI assistant (our template)" },
      other: { ru: "Живой рекрутер", en: "Human recruiter" },
    },
    comparisonRows: [
      {
        feature: { ru: "Время реакции", en: "Response time" },
        ai: { ru: "⚡ Секунды, 24/7", en: "⚡ Seconds, 24/7" },
        other: { ru: "⏳ Часы, только в рабочее время", en: "⏳ Hours, business hours only" },
      },
      {
        feature: { ru: "Одновременных диалогов", en: "Concurrent conversations" },
        ai: { ru: "🚀 Неограниченно (100+)", en: "🚀 Unlimited (100+)" },
        other: { ru: "🔻 3–5 параллельно", en: "🔻 3–5 in parallel" },
      },
      {
        feature: { ru: "Первичный скрининг", en: "Initial screening" },
        ai: { ru: "✅ Автоматический по скрипту", en: "✅ Automated by script" },
        other: { ru: "🤔 Ручной, тратит время", en: "🤔 Manual and time-consuming" },
      },
      {
        feature: { ru: "Запись на собеседование", en: "Interview scheduling" },
        ai: { ru: "📅 Авто (интеграция с календарём)", en: "📅 Automatic (calendar integration)" },
        other: { ru: "📞 Ручная переписка / звонки", en: "📞 Manual messaging / calls" },
      },
      {
        feature: { ru: "Стоимость за диалог", en: "Cost per conversation" },
        ai: { ru: "💰 Стремится к нулю", en: "💰 Trends toward zero" },
        other: { ru: "💸 Зарплата + налоги", en: "💸 Salary + taxes" },
      },
      {
        feature: { ru: "Качество коммуникации", en: "Communication quality" },
        ai: { ru: "📝 Идеально по скрипту, не устаёт", en: "📝 Consistent and script-based, never tired" },
        other: { ru: "🎭 Зависит от настроения", en: "🎭 Depends on mood" },
      },
      {
        feature: { ru: "Масштабирование (новые вакансии)", en: "Scaling to new vacancies" },
        ai: { ru: "🔄 Мгновенно (загрузили — и готово)", en: "🔄 Instant (upload and go)" },
        other: { ru: "🐢 Нужно нанимать и учить", en: "🐢 Requires hiring and training" },
      },
    ],
    stepsTitle: { ru: "Как это работает за 3 шага", en: "How it works in 3 steps" },
    steps: [
      {
        title: { ru: "Загрузите базу знаний", en: "Upload your knowledge base" },
        description: {
          ru: "Добавьте описания вакансий, информацию о компании, соцпакет. Можно загрузить PDF или указать ссылку на страницу карьеры.",
          en: "Add vacancy descriptions, company information, and benefits. You can upload a PDF or link to your careers page.",
        },
      },
      {
        title: { ru: "Выберите шаблон «Рекрутер»", en: "Choose the “Recruiter” template" },
        description: {
          ru: "Мы уже добавили типовые вопросы для скрининга и сценарии записи. При желании легко редактировать.",
          en: "We already added screening questions and scheduling scenarios. You can easily edit them if needed.",
        },
      },
      {
        title: { ru: "Вставьте виджет на сайт", en: "Embed the widget on your website" },
        description: {
          ru: "Код на страницу /career или /vacancies. Или используйте интеграции с WordPress, Tilda — и ассистент готов общаться.",
          en: "Add the code to your /career or /vacancies page, or use WordPress and Tilda integrations, and the assistant is ready to talk.",
        },
      },
    ],
    testimonial: {
      quote: {
        ru: "«Раньше на закрытие массовой вакансии уходило 2 недели и 100% времени рекрутера. С AI-ассистентом — 5 дней, а рекрутер теперь закрывает 3 таких вакансии параллельно. Лучшее внедрение за год.»",
        en: "\"A mass-hiring vacancy used to take 2 weeks and 100% of a recruiter's time. With the AI assistant, it now takes 5 days, and one recruiter can handle 3 such vacancies in parallel. Best implementation of the year.\"",
      },
      author: {
        ru: "— Иван П., HR-директор",
        en: "— Ivan P., HR Director",
      },
    },
    ctaTitle: {
      ru: "Начните закрывать вакансии быстрее",
      en: "Start closing vacancies faster",
    },
    ctaDescription: {
      ru: "Протестируйте шаблон «Рекрутер» бесплатно. Настройка — 3 минуты.",
      en: "Try the “Recruiter” template for free. Setup takes 3 minutes.",
    },
  },
  orders: {
    badge: {
      ru: "🛒 Шаблон для приёма заказов",
      en: "🛒 Template for order acceptance",
    },
    title: {
      ru: "AI-ассистент для приёма заказов\nПринимает заказы 24/7 без выходных и задержек",
      en: "AI assistant for order intake\nAccepts orders 24/7 without weekends or delays",
    },
    description: {
      ru: "Уточняет детали (размер, адрес доставки, способ оплаты), формирует заказ и передаёт в исполнение, на кухню или в CRM — полностью автоматически.",
      en: "Clarifies details (size, delivery address, payment method), creates the order, and sends it to fulfillment, the kitchen, or CRM automatically.",
    },
    stats: {
      ru: "⚡ 3 минуты настройку · Обработка заказов 24/7 · Без потерь в нерабочее время",
      en: "⚡ 3 minutes to set up · Order processing 24/7 · No losses outside business hours",
    },
    audienceTitle: {
      ru: "Кому и зачем нужен этот шаблон",
      en: "Who this template is for and why it matters",
    },
    audienceDescription: {
      ru: "Цифровой сотрудник для ресторанов, интернет-магазинов, служб доставки и любого бизнеса, который хочет принимать заказы круглосуточно без расширения штата.",
      en: "A digital employee for restaurants, online stores, delivery services, and any business that wants to accept orders around the clock without expanding the team.",
    },
    features: [
      {
        emoji: "🛍️",
        title: { ru: "Приём заказов 24/7", en: "24/7 order acceptance" },
        description: {
          ru: "Клиент может оформить заказ в любое время — ночью, в выходные, в праздники. AI всегда на связи.",
          en: "Customers can place orders at any time: at night, on weekends, and on holidays. AI is always available.",
        },
      },
      {
        emoji: "📏",
        title: { ru: "Уточнение деталей", en: "Detail clarification" },
        description: {
          ru: "Спрашивает размер, цвет, количество, адрес доставки, время, способ оплаты — ничего не упускает.",
          en: "Asks about size, color, quantity, delivery address, timing, and payment method without missing anything.",
        },
      },
      {
        emoji: "🚚",
        title: { ru: "Расчёт доставки", en: "Delivery calculation" },
        description: {
          ru: "Проверяет зону доставки, рассчитывает стоимость, сообщает примерное время прибытия.",
          en: "Checks delivery zones, calculates the price, and reports the estimated arrival time.",
        },
      },
      {
        emoji: "💳",
        title: { ru: "Оплата и подтверждение", en: "Payment and confirmation" },
        description: {
          ru: "Принимает оплату (если интегрировано), отправляет подтверждение заказа и чек на email или в SMS.",
          en: "Accepts payment (if integrated) and sends order confirmation and receipt by email or SMS.",
        },
      },
      {
        emoji: "🔄",
        title: { ru: "Передача в исполнение", en: "Transfer to fulfillment" },
        description: {
          ru: "Автоматически отправляет заказ в CRM, на кухню, склад или водителю — без участия человека.",
          en: "Automatically sends the order to CRM, the kitchen, the warehouse, or the courier without human involvement.",
        },
      },
      {
        emoji: "📊",
        title: { ru: "Статистика заказов", en: "Order analytics" },
        description: {
          ru: "Видите, какие товары заказывают чаще, в какое время пик нагрузки, откуда клиенты.",
          en: "See which products are ordered most often, when demand peaks, and where customers come from.",
        },
      },
    ],
    problemTitle: { ru: "❌ Проблемы без AI", en: "❌ Problems without AI" },
    problems: [
      {
        ru: "Заказы теряются в нерабочее время — клиенты уходят к конкурентам",
        en: "Orders are lost outside business hours and customers go to competitors.",
      },
      {
        ru: "Операторы забывают уточнить важные детали (размер, этаж, код домофона)",
        en: "Operators forget to clarify important details such as size, floor, or intercom code.",
      },
      {
        ru: "Очереди в чат в пиковые часы — клиенты злятся и отменяют заказы",
        en: "Queues in chat during peak hours frustrate customers and lead to cancellations.",
      },
      {
        ru: "Ошибки при передаче заказа на кухню или водителю — человеческий фактор",
        en: "Human errors happen when passing orders to the kitchen or courier.",
      },
      {
        ru: "Нужно нанимать дополнительных операторов на вечерние смены и выходные",
        en: "You need extra operators for evening shifts and weekends.",
      },
    ],
    solutionTitle: { ru: "✅ Решения с Supchats", en: "✅ Solutions with Supchats" },
    solutions: [
      {
        ru: "AI принимает заказы 24/7 — ни один клиент не уходит без оформления",
        en: "AI accepts orders 24/7 so no customer leaves without placing an order.",
      },
      {
        ru: "Чёткие скрипты: ассистент всегда спросит всё необходимое",
        en: "Clear scripts ensure the assistant always asks for everything required.",
      },
      {
        ru: "Мгновенная обработка даже при 100+ одновременных заказах",
        en: "Instant processing even with 100+ simultaneous orders.",
      },
      {
        ru: "Автоматическая передача в CRM, на кухню или курьеру — без ошибок",
        en: "Automatic handoff to CRM, kitchen, or courier without mistakes.",
      },
      {
        ru: "Не нужны ночные смены и доплаты за праздники",
        en: "No night shifts or holiday surcharges are needed.",
      },
    ],
    comparisonTitle: {
      ru: "AI-ассистент против обычного оператора по приёму заказов",
      en: "AI assistant vs a regular order operator",
    },
    comparisonHeaders: {
      feature: { ru: "Характеристика", en: "Characteristic" },
      ai: { ru: "AI-ассистент (наш шаблон)", en: "AI assistant (our template)" },
      other: { ru: "Живой оператор", en: "Human operator" },
    },
    comparisonRows: [
      { feature: { ru: "Доступность", en: "Availability" }, ai: { ru: "🌙 24/7 без выходных", en: "🌙 24/7 without days off" }, other: { ru: "⏰ Только в смены", en: "⏰ Shift-based only" } },
      { feature: { ru: "Скорость приёма заказа", en: "Order intake speed" }, ai: { ru: "⚡ 1-2 минуты", en: "⚡ 1–2 minutes" }, other: { ru: "⏳ 5-10 минут, если нет очереди", en: "⏳ 5–10 minutes if there is no queue" } },
      { feature: { ru: "Одновременных заказов", en: "Concurrent orders" }, ai: { ru: "🚀 Неограниченно", en: "🚀 Unlimited" }, other: { ru: "🔻 1-2 заказа параллельно", en: "🔻 1–2 orders in parallel" } },
      { feature: { ru: "Ошибки в деталях", en: "Errors in details" }, ai: { ru: "✅ Исключены — строгий скрипт", en: "✅ Eliminated by strict scripting" }, other: { ru: "❌ Человеческий фактор", en: "❌ Human factor" } },
      { feature: { ru: "Передача в CRM/кухню", en: "Transfer to CRM/kitchen" }, ai: { ru: "🔄 Автоматически, мгновенно", en: "🔄 Automatic and instant" }, other: { ru: "📝 Ручной ввод, задержки", en: "📝 Manual entry with delays" } },
      { feature: { ru: "Стоимость за заказ", en: "Cost per order" }, ai: { ru: "💰 Минимальная", en: "💰 Minimal" }, other: { ru: "💸 Зарплата + налоги + ночные", en: "💸 Salary + taxes + night rates" } },
      { feature: { ru: "Масштабирование в пик", en: "Peak-time scalability" }, ai: { ru: "📈 Мгновенное", en: "📈 Instant" }, other: { ru: "🐢 Нужно нанимать людей", en: "🐢 Requires hiring people" } },
    ],
    stepsTitle: { ru: "Как это работает за 3 шага", en: "How it works in 3 steps" },
    steps: [
      {
        title: { ru: "Загрузите меню / каталог", en: "Upload your menu / catalog" },
        description: {
          ru: "Добавьте товары, цены, варианты (размеры, цвета), зоны и стоимость доставки. Можно загрузить прайс или указать ссылки.",
          en: "Add products, prices, options (sizes, colors), delivery zones, and fees. You can upload a price list or provide links.",
        },
      },
      {
        title: { ru: "Выберите шаблон «Приём заказов»", en: "Choose the “Order Acceptance” template" },
        description: {
          ru: "Мы уже настроили сценарии: выбор товара, уточнение деталей, адрес, оплата, передача в CRM.",
          en: "We already configured the flows for choosing a product, clarifying details, address, payment, and CRM transfer.",
        },
      },
      {
        title: { ru: "Подключите виджет и CRM", en: "Connect the widget and CRM" },
        description: {
          ru: "Вставьте код на сайт, в Telegram или WhatsApp. Настройте интеграцию с вашей CRM или отправку заказов на почту/в Telegram-чат.",
          en: "Embed the code on your website, Telegram, or WhatsApp. Set up CRM integration or send orders to email or a Telegram chat.",
        },
      },
    ],
    testimonial: {
      quote: {
        ru: "«Раньше в пятницу и субботу вечером у нас были часы ожидания — клиенты просто бросали заказы. С AI-ассистентом заказы принимаются мгновенно 24/7. Выручка в ночное время выросла на 40%, а операторы высыпаются и лучше работают днём.»",
        en: "\"On Friday and Saturday evenings we used to have long waits, and customers simply abandoned orders. With the AI assistant, orders are accepted instantly 24/7. Night-time revenue grew by 40%, and our operators are now better rested and more productive during the day.\"",
      },
      author: {
        ru: "— Дмитрий К., владелец службы доставки",
        en: "— Dmitry K., delivery service owner",
      },
    },
    ctaTitle: {
      ru: "Начните принимать заказы 24/7 без выходных",
      en: "Start accepting orders 24/7 without weekends",
    },
    ctaDescription: {
      ru: "Протестируйте шаблон «Приём заказов» бесплатно. Настройка — 3 минуты, карта не нужна.",
      en: "Try the “Order Acceptance” template for free. Setup takes 3 minutes and no card is required.",
    },
  },
  messenger: {
    badge: {
      ru: "📲 Шаблон для перевода в мессенджеры",
      en: "📲 Template for messenger redirect",
    },
    title: {
      ru: "AI-ассистент для переадресации\nПереводит клиентов в Telegram, WhatsApp и другие мессенджеры",
      en: "AI assistant for redirecting\nMoves customers to Telegram, WhatsApp, and other messengers",
    },
    description: {
      ru: "Предлагает продолжить общение в удобном мессенджере, собирает контакт и отправляет ссылку-приглашение. Идеально для личного общения и удержания клиентов.",
      en: "Offers to continue the conversation in a convenient messenger, collects contact details, and sends an invitation link. Perfect for personal communication and retention.",
    },
    stats: {
      ru: "⚡ 3 минуты настройку · Конверсия в подписку +65% · Без привязки карты",
      en: "⚡ 3 minutes to set up · +65% subscription conversion · No card required",
    },
    audienceTitle: {
      ru: "Кому и зачем нужен этот шаблон",
      en: "Who this template is for and why it matters",
    },
    audienceDescription: {
      ru: "Цифровой помощник для бизнеса, который хочет перенести общение с клиентами в мессенджеры — для более личного контакта, повышения лояльности и повторных продаж.",
      en: "A digital assistant for businesses that want to move customer communication into messengers for more personal contact, stronger loyalty, and repeat sales.",
    },
    features: [
      {
        emoji: "💬",
        title: { ru: "Перевод в Telegram / WhatsApp", en: "Redirect to Telegram / WhatsApp" },
        description: {
          ru: "В нужный момент предлагает клиенту продолжить общение в мессенджере — с учётом гео и предпочтений.",
          en: "At the right moment, invites the customer to continue in a messenger, taking geo and preferences into account.",
        },
      },
      {
        emoji: "📱",
        title: { ru: "Сбор контакта", en: "Contact collection" },
        description: {
          ru: "Запрашивает номер телефона или никнейм, чтобы отправить ссылку-приглашение прямо в чат.",
          en: "Requests a phone number or nickname to send an invitation link directly in chat.",
        },
      },
      {
        emoji: "🔗",
        title: { ru: "Автоматическая отправка ссылки", en: "Automatic link delivery" },
        description: {
          ru: "Генерирует и отправляет персональную ссылку на ваш Telegram-бот, WhatsApp-чат или канал.",
          en: "Generates and sends a personal link to your Telegram bot, WhatsApp chat, or channel.",
        },
      },
      {
        emoji: "🎯",
        title: { ru: "Выбор момента", en: "Timing selection" },
        description: {
          ru: "Можно настроить триггеры: после ответа на вопрос, при высоком интересе, перед выходом с сайта.",
          en: "You can configure triggers: after answering a question, at high intent, or right before leaving the site.",
        },
      },
      {
        emoji: "📊",
        title: { ru: "Аналитика переходов", en: "Redirect analytics" },
        description: {
          ru: "Видите, сколько клиентов согласились уйти в мессенджер, по какой ссылке перешли, откуда пришли.",
          en: "See how many customers agreed to move to a messenger, which link they used, and where they came from.",
        },
      },
      {
        emoji: "🔄",
        title: { ru: "Передача контакта в CRM", en: "CRM contact transfer" },
        description: {
          ru: "Номер или ID мессенджера сохраняется в CRM для дальнейшей работы и сегментации.",
          en: "The phone number or messenger ID is saved to CRM for follow-up and segmentation.",
        },
      },
    ],
    problemTitle: { ru: "❌ Проблемы без AI", en: "❌ Problems without AI" },
    problems: [
      {
        ru: "Клиенты уходят с сайта и теряются — нет возможности написать им повторно",
        en: "Customers leave the website and are lost because there is no way to contact them again.",
      },
      {
        ru: "Операторы вручную просят \"напишите нам в Telegram\" — низкая конверсия",
        en: "Operators manually ask users to “message us on Telegram,” resulting in low conversion.",
      },
      {
        ru: "Нет автоматического сбора контактов мессенджеров для ретаргетинга",
        en: "There is no automatic collection of messenger contacts for retargeting.",
      },
      {
        ru: "Сложно измерить, сколько людей реально перешло в мессенджер",
        en: "It is difficult to measure how many people actually moved into a messenger.",
      },
      {
        ru: "Упущенные продажи, потому что клиент не захотел общаться в чате на сайте",
        en: "Sales are lost because some customers do not want to continue inside an on-site chat.",
      },
    ],
    solutionTitle: { ru: "✅ Решения с Supchats", en: "✅ Solutions with Supchats" },
    solutions: [
      {
        ru: "Клиент остаётся с вами в мессенджере — можно делать рассылки, напоминать о себе",
        en: "The customer stays with you in a messenger, so you can send campaigns and reminders later.",
      },
      {
        ru: "AI предлагает перейти в мессенджер в идеальный момент, конверсия до 65%",
        en: "AI suggests moving to a messenger at the perfect moment, reaching up to 65% conversion.",
      },
      {
        ru: "База контактов мессенджеров растёт автоматически",
        en: "Your messenger contact base grows automatically.",
      },
      {
        ru: "Полная статистика: сколько предложили, сколько согласились, сколько перешли",
        en: "You get full statistics: how many offers were shown, how many accepted, and how many completed the move.",
      },
      {
        ru: "Клиенты выбирают удобный канал — лояльность растёт",
        en: "Customers choose the channel they prefer, which increases loyalty.",
      },
    ],
    comparisonTitle: {
      ru: "AI-ассистент против ручного сбора контактов",
      en: "AI assistant vs manual contact collection",
    },
    comparisonHeaders: {
      feature: { ru: "Характеристика", en: "Characteristic" },
      ai: { ru: "AI-ассистент (наш шаблон)", en: "AI assistant (our template)" },
      other: { ru: "Ручной сбор оператором", en: "Manual collection by operator" },
    },
    comparisonRows: [
      { feature: { ru: "Конверсия в подписку", en: "Subscription conversion" }, ai: { ru: "📈 До 65%", en: "📈 Up to 65%" }, other: { ru: "📉 5-10% (если вообще просят)", en: "📉 5–10% (if they ask at all)" } },
      { feature: { ru: "Скорость", en: "Speed" }, ai: { ru: "⚡ Мгновенно, в диалоге", en: "⚡ Instant, inside the conversation" }, other: { ru: "⏳ Зависит от оператора", en: "⏳ Depends on the operator" } },
      { feature: { ru: "Выбор момента", en: "Timing" }, ai: { ru: "🎯 По триггерам (интерес, выход)", en: "🎯 Trigger-based (interest, exit intent)" }, other: { ru: "🤷 Случайно или забывают", en: "🤷 Random or forgotten" } },
      { feature: { ru: "Сбор контакта", en: "Contact capture" }, ai: { ru: "✅ Автоматически, без ошибок", en: "✅ Automatic and error-free" }, other: { ru: "📝 Ручной ввод, опечатки", en: "📝 Manual entry with typos" } },
      { feature: { ru: "Передача в CRM", en: "Transfer to CRM" }, ai: { ru: "🔄 Мгновенно", en: "🔄 Instant" }, other: { ru: "📋 Только если не забыли", en: "📋 Only if they remember" } },
      { feature: { ru: "Масштабирование", en: "Scalability" }, ai: { ru: "🚀 Тысячи диалогов", en: "🚀 Thousands of conversations" }, other: { ru: "🔻 Ограничено штатом", en: "🔻 Limited by staff" } },
      { feature: { ru: "Аналитика", en: "Analytics" }, ai: { ru: "📊 Полный отчёт", en: "📊 Full reporting" }, other: { ru: "❌ Нет данных", en: "❌ No data" } },
    ],
    stepsTitle: { ru: "Как это работает за 3 шага", en: "How it works in 3 steps" },
    steps: [
      {
        title: { ru: "Подключите мессенджеры", en: "Connect your messengers" },
        description: {
          ru: "Укажите ссылки на ваш Telegram-бот, WhatsApp-чат, Viber или любой другой мессенджер, куда хотите переводить клиентов.",
          en: "Provide links to your Telegram bot, WhatsApp chat, Viber, or any other messenger where you want to redirect customers.",
        },
      },
      {
        title: { ru: "Выберите шаблон «Переадресация»", en: "Choose the “Messenger Redirect” template" },
        description: {
          ru: "Мы уже настроили сценарии: предложение перейти в мессенджер, сбор контакта, отправка ссылки. Можно настроить триггеры.",
          en: "We already configured the flow: suggest moving to a messenger, collect contact details, and send the link. Triggers can be customized.",
        },
      },
      {
        title: { ru: "Разместите виджет на сайте", en: "Place the widget on your website" },
        description: {
          ru: "Вставьте код на сайт — ассистент начнёт собирать подписчиков в мессенджеры через минуту. Контакты сохраняются в CRM.",
          en: "Embed the code on your website, and the assistant will begin collecting messenger subscribers within a minute. Contacts are saved to CRM.",
        },
      },
    ],
    testimonial: {
      quote: {
        ru: "«Мы давно хотели собирать базу в Telegram, но ручные призывы работали плохо. С AI-ассистентом за месяц собрали 1200 контактов — конверсия 58%. Теперь делаем рассылки по новой базе и продаём без рекламы.»",
        en: "\"We had wanted to grow a Telegram audience for a long time, but manual prompts worked poorly. With the AI assistant, we collected 1,200 contacts in one month with a 58% conversion rate. Now we run campaigns to this new base and sell without extra ad spend.\"",
      },
      author: {
        ru: "— Андрей Л., маркетолог интернет-магазина",
        en: "— Andrey L., e-commerce marketer",
      },
    },
    ctaTitle: {
      ru: "Начните собирать подписчиков в мессенджеры",
      en: "Start collecting subscribers in messengers",
    },
    ctaDescription: {
      ru: "Протестируйте шаблон «Переадресация в мессенджер» бесплатно. Настройка — 3 минуты, карта не нужна.",
      en: "Try the “Messenger Redirect” template for free. Setup takes 3 minutes and no card is required.",
    },
  },
  support: {
    badge: {
      ru: "🛠️ Шаблон для технической поддержки",
      en: "🛠️ Template for technical support",
    },
    title: {
      ru: "AI-ассистент для поддержки\nОтвечает на вопросы 24/7 на основе вашей базы знаний",
      en: "AI assistant for support\nAnswers questions 24/7 based on your knowledge base",
    },
    description: {
      ru: "Мгновенно решает типовые вопросы клиентов, используя FAQ, документацию и инструкции. Сложные кейсы передаёт операторам с полным контекстом.",
      en: "Instantly resolves routine customer questions using FAQ, documentation, and instructions. Hands over complex cases to operators with full context.",
    },
    stats: {
      ru: "⚡ 3 минуты на настройку · Снижение нагрузки на поддержку до 70% · Без привязки карты",
      en: "⚡ 3 minutes to set up · Reduce support workload by up to 70% · No card required",
    },
    audienceTitle: {
      ru: "Кому и зачем нужен этот шаблон",
      en: "Who this template is for and why it matters",
    },
    audienceDescription: {
      ru: "Цифровой сотрудник поддержки для компаний, которые хотят отвечать клиентам мгновенно, но не нанимать десятки операторов.",
      en: "A digital support employee for companies that want to answer customers instantly without hiring dozens of operators.",
    },
    features: [
      {
        emoji: "📚",
        title: { ru: "Работа с базой знаний", en: "Knowledge base support" },
        description: {
          ru: "Загрузите FAQ, статьи, документацию, инструкции — AI найдёт ответ в любом файле (PDF, Word, ссылки).",
          en: "Upload FAQ, articles, documentation, and instructions. AI finds the answer across files, PDFs, Word docs, and links.",
        },
      },
      {
        emoji: "⚡",
        title: { ru: "Мгновенные ответы 24/7", en: "Instant replies 24/7" },
        description: {
          ru: "Клиент получает ответ за секунду — в любое время суток, без выходных и очередей.",
          en: "Customers get answers in seconds, at any time of day, with no weekends and no queues.",
        },
      },
      {
        emoji: "🔄",
        title: { ru: "Эскалация оператору", en: "Operator escalation" },
        description: {
          ru: "Если вопрос сложный или клиент просит человека — AI передаёт диалог оператору с полной историей.",
          en: "If the issue is complex or the customer asks for a human, AI transfers the conversation to an operator with full history.",
        },
      },
      {
        emoji: "📊",
        title: { ru: "Аналитика обращений", en: "Support analytics" },
        description: {
          ru: "Видите топ вопросов, качество ответов и нагрузку — понимаете, что доработать в базе знаний.",
          en: "See top questions, answer quality, and workload so you know what to improve in the knowledge base.",
        },
      },
      {
        emoji: "🌍",
        title: { ru: "Многоязычность", en: "Multilingual support" },
        description: {
          ru: "Отвечает на языке клиента автоматически — не нужно нанимать поддержку под каждый регион.",
          en: "Replies in the customer’s language automatically, so you do not need separate support teams for each region.",
        },
      },
      {
        emoji: "🎯",
        title: { ru: "Единые стандарты", en: "Unified standards" },
        description: {
          ru: "Все ответы строго по документации — никакой самодеятельности и противоречивых инструкций.",
          en: "Every answer follows documentation strictly, with no improvisation or contradictory instructions.",
        },
      },
    ],
    problemTitle: { ru: "❌ Проблемы без AI", en: "❌ Problems without AI" },
    problems: [
      {
        ru: "Клиенты ждут ответа часами, а в выходные — до понедельника",
        en: "Customers wait for hours, and on weekends they may wait until Monday.",
      },
      {
        ru: "Операторы перегружены однотипными вопросами «как войти?», «где скачать?»",
        en: "Operators are overloaded with repetitive questions like “how do I log in?” and “where do I download it?”",
      },
      {
        ru: "Новички в поддержке долго ищут ответы в документации",
        en: "New support agents spend too much time searching documentation.",
      },
      {
        ru: "Качество ответов скачет — каждый оператор отвечает по-своему",
        en: "Answer quality varies because every operator responds differently.",
      },
      {
        ru: "В пиковые нагрузки поддержка просто не справляется",
        en: "During peak load, support simply cannot keep up.",
      },
    ],
    solutionTitle: { ru: "✅ Решения с Supchats", en: "✅ Solutions with Supchats" },
    solutions: [
      {
        ru: "AI отвечает мгновенно 24/7 — клиенты счастливы, даже ночью",
        en: "AI responds instantly 24/7, keeping customers satisfied even at night.",
      },
      {
        ru: "70% типовых вопросов AI закрывает сам — операторы занимаются только сложными кейсами",
        en: "AI resolves up to 70% of standard questions, so operators focus only on complex cases.",
      },
      {
        ru: "Мгновенный поиск по базе знаний — AI находит ответ быстрее любого человека",
        en: "Instant knowledge-base search lets AI find answers faster than any human.",
      },
      {
        ru: "Единые ответы строго по документации — бренд не страдает",
        en: "Unified answers based strictly on documentation protect your brand quality.",
      },
      {
        ru: "AI держит любую нагрузку — хоть 1000 параллельных диалогов",
        en: "AI handles any load, even 1,000 parallel conversations.",
      },
    ],
    comparisonTitle: {
      ru: "AI-ассистент против обычного оператора поддержки",
      en: "AI assistant vs a regular support operator",
    },
    comparisonHeaders: {
      feature: { ru: "Характеристика", en: "Characteristic" },
      ai: { ru: "AI-ассистент (наш шаблон)", en: "AI assistant (our template)" },
      other: { ru: "Живой оператор", en: "Human operator" },
    },
    comparisonRows: [
      { feature: { ru: "Время ответа", en: "Response time" }, ai: { ru: "⚡ 1 секунда", en: "⚡ 1 second" }, other: { ru: "⏳ От 2 минут до нескольких часов", en: "⏳ From 2 minutes to several hours" } },
      { feature: { ru: "Доступность", en: "Availability" }, ai: { ru: "🌙 24/7 без выходных", en: "🌙 24/7 without days off" }, other: { ru: "⏰ Только в рабочее время / по сменам", en: "⏰ Business hours / shifts only" } },
      { feature: { ru: "Типовые вопросы", en: "Routine questions" }, ai: { ru: "✅ Закрывает 70-80% автоматически", en: "✅ Resolves 70–80% automatically" }, other: { ru: "🤔 Тратит 80% времени на рутину", en: "🤔 Spends 80% of time on routine" } },
      { feature: { ru: "Поиск в базе знаний", en: "Knowledge-base search" }, ai: { ru: "📚 Мгновенный по всем документам", en: "📚 Instant across all documents" }, other: { ru: "📖 Листает вручную, тратит минуты", en: "📖 Manual lookup taking minutes" } },
      { feature: { ru: "Качество ответов", en: "Answer quality" }, ai: { ru: "📝 Всегда по документации", en: "📝 Always documentation-based" }, other: { ru: "🎭 Зависит от опыта и настроения", en: "🎭 Depends on experience and mood" } },
      { feature: { ru: "Масштабирование (нагрузка)", en: "Scalability under load" }, ai: { ru: "🚀 Безгранично", en: "🚀 Limitless" }, other: { ru: "🔻 Нужно нанимать людей", en: "🔻 Requires hiring more people" } },
      { feature: { ru: "Передача сложного кейса", en: "Complex case handoff" }, ai: { ru: "🔄 С полным контекстом оператору", en: "🔄 Sent to operator with full context" }, other: { ru: "🤷 Клиент пересказывает всё заново", en: "🤷 Customer has to repeat everything" } },
    ],
    stepsTitle: { ru: "Как это работает за 3 шага", en: "How it works in 3 steps" },
    steps: [
      {
        title: { ru: "Загрузите базу знаний", en: "Upload your knowledge base" },
        description: {
          ru: "Добавьте все материалы поддержки: FAQ, инструкции, статьи, документацию. Можно загрузить файлы или указать ссылки.",
          en: "Add all support materials: FAQ, instructions, articles, and documentation. You can upload files or provide links.",
        },
      },
      {
        title: { ru: "Выберите шаблон «Техподдержка»", en: "Choose the “Tech Support” template" },
        description: {
          ru: "Мы уже настроили сценарии: приветствие, ответы на частые вопросы, правила эскалации оператору.",
          en: "We already configured greeting flows, answers to frequent questions, and escalation rules for operators.",
        },
      },
      {
        title: { ru: "Разместите виджет на сайте", en: "Place the widget on the website" },
        description: {
          ru: "Вставьте код на сайт — ассистент начнёт отвечать клиентам через минуту. Операторы подключатся к сложным вопросам в том же интерфейсе.",
          en: "Insert the code on your website, and the assistant will start answering customers within minutes. Operators can join complex conversations in the same interface.",
        },
      },
    ],
    testimonial: {
      quote: {
        ru: "«В первый же месяц AI-ассистент закрыл 73% всех обращений в поддержку. Операторы перестали тонуть в рутине и наконец-то начали решать действительно сложные проблемы клиентов. Лучшее, что мы сделали для поддержки за последние 2 года.»",
        en: "\"In the very first month, the AI assistant handled 73% of all support requests. Operators stopped drowning in routine and finally started solving truly complex customer problems. The best thing we have done for support in the last two years.\"",
      },
      author: {
        ru: "— Алексей Н., руководитель клиентского сервиса",
        en: "— Alexey N., Head of Customer Service",
      },
    },
    ctaTitle: {
      ru: "Разгрузите поддержку уже сегодня",
      en: "Lighten your support load today",
    },
    ctaDescription: {
      ru: "Протестируйте шаблон «Техподдержка» бесплатно. Настройка — 3 минуты, карта не нужна.",
      en: "Try the “Tech Support” template for free. Setup takes 3 minutes and no card is required.",
    },
  },
  education: {
    badge: {
      ru: "🎓 Шаблон для онлайн-школ и курсов",
      en: "🎓 Template for online schools and courses",
    },
    title: {
      ru: "AI-ассистент для образования\nПомогает студентам и приводит новых учеников 24/7",
      en: "AI assistant for education\nSupports students and brings in new learners 24/7",
    },
    description: {
      ru: "Отвечает на вопросы о программах и тарифах, помогает с записью, напоминает о дедлайнах и сопровождает студентов на протяжении обучения.",
      en: "Answers questions about programs and pricing, helps with enrollment, reminds about deadlines, and supports students throughout the learning process.",
    },
    stats: {
      ru: "⚡ 3 минуты на настройку · Меньше нагрузки на кураторов · Без привязки карты",
      en: "⚡ 3 minutes to set up · Less load on coordinators · No card required",
    },
    audienceTitle: {
      ru: "Кому и зачем нужен этот шаблон",
      en: "Who this template is for and why it matters",
    },
    audienceDescription: {
      ru: "Готовое решение для онлайн-школ, учебных центров и курсов, которым важно быстро отвечать абитуриентам и студентам без расширения команды.",
      en: "A ready-made solution for online schools, training centers, and courses that need to respond quickly to prospective and current students without growing the team.",
    },
    features: [
      {
        emoji: "📚",
        title: { ru: "Ответы о курсах и программах", en: "Answers about courses and programs" },
        description: {
          ru: "Рассказывает о формате обучения, стоимости, расписании и содержании программ.",
          en: "Explains learning format, pricing, schedules, and program content.",
        },
      },
      {
        emoji: "📝",
        title: { ru: "Помощь с записью", en: "Enrollment assistance" },
        description: {
          ru: "Собирает контакты, подбирает подходящий курс и помогает довести пользователя до регистрации.",
          en: "Collects contacts, helps choose the right course, and guides the user to registration.",
        },
      },
      {
        emoji: "⏰",
        title: { ru: "Напоминания о дедлайнах", en: "Deadline reminders" },
        description: {
          ru: "Напоминает о старте потока, оплате, дедлайнах по домашним заданиям и вебинарах.",
          en: "Reminds about cohort start dates, payments, homework deadlines, and webinars.",
        },
      },
      {
        emoji: "💬",
        title: { ru: "Поддержка студентов", en: "Student support" },
        description: {
          ru: "Отвечает на частые вопросы о доступе, материалах, сертификатах и процессе обучения.",
          en: "Answers common questions about access, materials, certificates, and the learning process.",
        },
      },
      {
        emoji: "🔄",
        title: { ru: "Передача куратору", en: "Handoff to a coordinator" },
        description: {
          ru: "Если вопрос сложный или требуется личная консультация, переводит диалог куратору с контекстом.",
          en: "If the issue is complex or a personal consultation is needed, it hands the conversation to a coordinator with full context.",
        },
      },
      {
        emoji: "📊",
        title: { ru: "Аналитика обращений", en: "Inquiry analytics" },
        description: {
          ru: "Показывает, какие программы спрашивают чаще, где теряются заявки и какие вопросы мешают покупке.",
          en: "Shows which programs are asked about most often, where leads drop off, and what questions block conversion.",
        },
      },
    ],
    problemTitle: { ru: "❌ Проблемы без AI", en: "❌ Problems without AI" },
    problems: [
      {
        ru: "Заявки на курсы приходят ночью и в выходные, но ответа приходится ждать",
        en: "Course inquiries arrive at night and on weekends, but replies come too late.",
      },
      {
        ru: "Кураторы тратят время на одни и те же вопросы о стоимости, формате и дедлайнах",
        en: "Coordinators spend time answering the same questions about price, format, and deadlines.",
      },
      {
        ru: "Потенциальные студенты теряются между первым интересом и оплатой курса",
        en: "Prospective students get lost between first interest and course payment.",
      },
      {
        ru: "У действующих студентов нет быстрого ответа по доступу и материалам",
        en: "Current students do not get quick answers about access and learning materials.",
      },
    ],
    solutionTitle: { ru: "✅ Решения с Supchats", en: "✅ Solutions with Supchats" },
    solutions: [
      {
        ru: "AI отвечает будущим и текущим студентам 24/7 — без задержек и очередей",
        en: "AI answers both prospective and current students 24/7 without delays or queues.",
      },
      {
        ru: "Автоматически закрывает частые вопросы и разгружает кураторов",
        en: "Automatically handles frequent questions and reduces coordinator workload.",
      },
      {
        ru: "Подталкивает к записи, оплате и участию в следующем потоке",
        en: "Moves users toward enrollment, payment, and participation in the next cohort.",
      },
      {
        ru: "Передаёт сложные кейсы человеку только тогда, когда это действительно нужно",
        en: "Escalates complex cases to a human only when truly necessary.",
      },
    ],
    comparisonTitle: {
      ru: "AI-ассистент против ручной обработки заявок в образовании",
      en: "AI assistant vs manual handling of education inquiries",
    },
    comparisonHeaders: {
      feature: { ru: "Характеристика", en: "Characteristic" },
      ai: { ru: "AI-ассистент (наш шаблон)", en: "AI assistant (our template)" },
      other: { ru: "Ручная работа команды", en: "Manual team workflow" },
    },
    comparisonRows: [
      { feature: { ru: "Время ответа", en: "Response time" }, ai: { ru: "⚡ Мгновенно, 24/7", en: "⚡ Instant, 24/7" }, other: { ru: "⏳ Зависит от графика команды", en: "⏳ Depends on team schedule" } },
      { feature: { ru: "Ответы по программам", en: "Program explanations" }, ai: { ru: "📚 Всегда по базе знаний", en: "📚 Always based on the knowledge base" }, other: { ru: "📝 Ручные ответы, не всегда одинаковые", en: "📝 Manual answers, not always consistent" } },
      { feature: { ru: "Работа с заявками", en: "Lead handling" }, ai: { ru: "🚀 Без ограничений по количеству", en: "🚀 No limit on volume" }, other: { ru: "🔻 Ограничено числом кураторов", en: "🔻 Limited by the number of coordinators" } },
      { feature: { ru: "Поддержка студентов", en: "Student support" }, ai: { ru: "✅ Быстро и по скрипту", en: "✅ Fast and script-based" }, other: { ru: "🤷 Зависит от загрузки", en: "🤷 Depends on workload" } },
      { feature: { ru: "Масштабирование", en: "Scalability" }, ai: { ru: "📈 Мгновенно", en: "📈 Instant" }, other: { ru: "🐢 Нужно расширять команду", en: "🐢 Requires team growth" } },
    ],
    stepsTitle: { ru: "Как это работает за 3 шага", en: "How it works in 3 steps" },
    steps: [
      {
        title: { ru: "Загрузите программы и FAQ", en: "Upload programs and FAQ" },
        description: {
          ru: "Добавьте описания курсов, цены, расписание, правила доступа и учебные материалы.",
          en: "Add course descriptions, pricing, schedules, access rules, and learning materials.",
        },
      },
      {
        title: { ru: "Выберите шаблон «Образование»", en: "Choose the “Education” template" },
        description: {
          ru: "Мы уже подготовили сценарии для записи на курс, поддержки студентов и ответов на частые вопросы.",
          en: "We already prepared flows for enrollment, student support, and answers to common questions.",
        },
      },
      {
        title: { ru: "Подключите виджет на сайт", en: "Connect the widget to your website" },
        description: {
          ru: "Вставьте код на страницу курса или лендинг — ассистент начнёт работать с учениками и заявками сразу.",
          en: "Embed the code on the course page or landing page, and the assistant will start working with leads and students immediately.",
        },
      },
    ],
    testimonial: {
      quote: {
        ru: "«После подключения AI-ассистента мы стали быстрее обрабатывать заявки на новые потоки и почти перестали терять студентов на этапе выбора программы. Кураторы освободили время для реальной работы с учениками.»",
        en: "\"After подключing the AI assistant, we started processing applications for new cohorts much faster and almost stopped losing students at the program-selection stage. Coordinators freed up time for real student support.\"",
      },
      author: {
        ru: "— Мария С., руководитель онлайн-школы",
        en: "— Maria S., head of an online school",
      },
    },
    ctaTitle: {
      ru: "Помогайте студентам и привлекайте новых учеников быстрее",
      en: "Support students and attract new learners faster",
    },
    ctaDescription: {
      ru: "Протестируйте шаблон «Образование» бесплатно. Настройка займёт около 3 минут.",
      en: "Try the “Education” template for free. Setup takes about 3 minutes.",
    },
  },
  sales: {
    badge: {
      ru: "💰 Шаблон для продаж и лидогенерации",
      en: "💰 Template for sales and lead generation",
    },
    title: {
      ru: "Продажи и сбор контактов",
      en: "Sales and contact collection",
    },
    description: {
      ru: "Автоматически собирает имя, email и телефон посетителей, определяет интерес к продукту и передаёт тёплые лиды в CRM или отдел продаж.",
      en: "Automatically collects visitor name, email, and phone, identifies product interest, and sends warm leads to CRM or your sales team.",
    },
    stats: {
      ru: "⚡ 3 минуты на настройку · Конверсия в контакт +40% · Без привязки карты",
      en: "⚡ 3 minutes to set up · +40% contact conversion · No card required",
    },
    audienceTitle: {
      ru: "Кому и зачем нужен этот шаблон",
      en: "Who this template is for and why it matters",
    },
    audienceDescription: {
      ru: "Цифровой продажник для компаний, которые хотят получать больше лидов с сайта, не расширяя отдел продаж.",
      en: "A digital salesperson for companies that want more leads from their website without expanding the sales team.",
    },
    features: [
      {
        emoji: "📋",
        title: { ru: "Сбор контактов", en: "Contact collection" },
        description: {
          ru: "Автоматически запрашивает имя, email и телефон в диалоге — конверсия в 3 раза выше, чем у обычных форм.",
          en: "Automatically asks for name, email, and phone in a conversation, with conversion up to 3x higher than classic forms.",
        },
      },
      {
        emoji: "🎯",
        title: { ru: "Квалификация лидов", en: "Lead qualification" },
        description: {
          ru: "Определяет бюджет, срочность, потребность и выявляет «горячих» клиентов до передачи менеджеру.",
          en: "Identifies budget, urgency, and need, and detects hot leads before handing them to a manager.",
        },
      },
      {
        emoji: "🔄",
        title: { ru: "Отправка в CRM", en: "Transfer to CRM" },
        description: {
          ru: "Интеграция с AmoCRM, Bitrix24, HubSpot и любыми системами через вебхуки — лиды приходят уже с тегами.",
          en: "Integrates with AmoCRM, Bitrix24, HubSpot, and any system through webhooks, with leads arriving already tagged.",
        },
      },
      {
        emoji: "⏰",
        title: { ru: "Автоворонка", en: "Automated nurturing" },
        description: {
          ru: "Если менеджер не взял диалог сразу — AI продолжает общение, отвечает на вопросы и подогревает интерес.",
          en: "If a manager does not take over immediately, AI keeps the conversation going, answers questions, and nurtures interest.",
        },
      },
      {
        emoji: "📊",
        title: { ru: "Аналитика по лидам", en: "Lead analytics" },
        description: {
          ru: "Видите, сколько контактов собрано, какие товары интересуют, откуда пришли клиенты.",
          en: "See how many contacts were collected, which products they are interested in, and where they came from.",
        },
      },
      {
        emoji: "💬",
        title: { ru: "Автоответы на частые вопросы", en: "Automatic FAQ answers" },
        description: {
          ru: "Отвечает про цену, доставку, гарантию — не отвлекая менеджеров на рутину.",
          en: "Answers questions about price, delivery, and warranty without distracting managers with routine tasks.",
        },
      },
    ],
    problemTitle: { ru: "❌ Проблемы без AI", en: "❌ Problems without AI" },
    problems: [
      {
        ru: "Посетители уходят, потому что форма захвата слишком длинная",
        en: "Visitors leave because the lead capture form is too long.",
      },
      {
        ru: "Менеджеры тратят 50% времени на ответы «сколько стоит?» вместо продаж",
        en: "Managers spend 50% of their time answering “how much does it cost?” instead of selling.",
      },
      {
        ru: "В CRM попадают сырые лиды без квалификации — непонятно, кому звонить первым",
        en: "Raw, unqualified leads reach CRM, making it unclear who should be called first.",
      },
      {
        ru: "Ночью и в выходные лиды просто теряются — никто не отвечает",
        en: "At night and on weekends, leads are simply lost because no one replies.",
      },
    ],
    solutionTitle: { ru: "✅ Решения с Supchats", en: "✅ Solutions with Supchats" },
    solutions: [
      {
        ru: "Сбор контактов в естественном диалоге — люди охотнее оставляют данные",
        en: "Contact collection happens in a natural conversation, so people leave their details more willingly.",
      },
      {
        ru: "AI отвечает на типовые вопросы мгновенно, разгружая отдел продаж",
        en: "AI answers routine questions instantly, reducing pressure on the sales team.",
      },
      {
        ru: "Каждый лид приходит с BANT-квалификацией (бюджет, полномочия, потребность, сроки)",
        en: "Every lead arrives already BANT-qualified (budget, authority, need, timeline).",
      },
      {
        ru: "Ассистент работает 24/7 — ни один лид не теряется в нерабочее время",
        en: "The assistant works 24/7, so no lead is lost outside business hours.",
      },
    ],
    comparisonTitle: {
      ru: "AI-ассистент против обычного менеджера на первом касании",
      en: "AI assistant vs a regular sales manager at first contact",
    },
    comparisonHeaders: {
      feature: { ru: "Характеристика", en: "Characteristic" },
      ai: { ru: "AI-ассистент (наш шаблон)", en: "AI assistant (our template)" },
      other: { ru: "Живой менеджер", en: "Human manager" },
    },
    comparisonRows: [
      { feature: { ru: "Скорость ответа", en: "Response speed" }, ai: { ru: "⚡ 1 секунда, 24/7", en: "⚡ 1 second, 24/7" }, other: { ru: "⏳ От 5 минут до нескольких часов", en: "⏳ From 5 minutes to several hours" } },
      { feature: { ru: "Сбор контактов", en: "Contact collection" }, ai: { ru: "📋 Автоматически в диалоге (конверсия до 80%)", en: "📋 Automatic in chat (up to 80% conversion)" }, other: { ru: "📝 Ручной ввод, забывают спросить", en: "📝 Manual entry, often forgotten" } },
      { feature: { ru: "Квалификация лида", en: "Lead qualification" }, ai: { ru: "✅ BANT-скрининг у каждого лида", en: "✅ BANT screening for every lead" }, other: { ru: "🤔 Только если не забыл спросить", en: "🤔 Only if they remember to ask" } },
      { feature: { ru: "Обработка ночью", en: "Night-time handling" }, ai: { ru: "🌙 Работает всегда", en: "🌙 Always available" }, other: { ru: "💤 Теряются лиды", en: "💤 Leads are lost" } },
      { feature: { ru: "Передача в CRM", en: "Transfer to CRM" }, ai: { ru: "🔄 Мгновенно, с тегами", en: "🔄 Instant, with tags" }, other: { ru: "📝 Ручной ввод, ошибки", en: "📝 Manual entry, with errors" } },
      { feature: { ru: "Количество лидов одновременно", en: "Concurrent lead volume" }, ai: { ru: "🚀 Неограниченно", en: "🚀 Unlimited" }, other: { ru: "🔻 3–5 параллельно", en: "🔻 3–5 in parallel" } },
      { feature: { ru: "Автосопровождение", en: "Automated follow-up" }, ai: { ru: "📧 Отправляет коммерческие предложения, напоминает", en: "📧 Sends offers and reminders" }, other: { ru: "🤷 Только если успевает", en: "🤷 Only if there is time" } },
    ],
    stepsTitle: { ru: "Как это работает за 3 шага", en: "How it works in 3 steps" },
    steps: [
      {
        title: { ru: "Загрузите информацию о продуктах", en: "Upload product information" },
        description: {
          ru: "Опишите товары/услуги, цены, акции, условия доставки. Или загрузите файлы с прайсами и FAQ.",
          en: "Describe products/services, prices, promotions, and delivery terms. Or upload files with price lists and FAQ.",
        },
      },
      {
        title: { ru: "Выберите шаблон «Продажи»", en: "Choose the “Sales” template" },
        description: {
          ru: "Мы уже добавили сценарии сбора контактов, квалификации и ответов на частые вопросы.",
          en: "We already added flows for contact capture, qualification, and answers to frequent questions.",
        },
      },
      {
        title: { ru: "Подключите CRM и виджет", en: "Connect CRM and the widget" },
        description: {
          ru: "Достаточно вставить код на сайт — ассистент начнёт собирать лиды через минуту. Данные уходят в вашу CRM автоматически.",
          en: "Just embed the code on your site and the assistant will start collecting leads within minutes. Data flows automatically to your CRM.",
        },
      },
    ],
    testimonial: {
      quote: {
        ru: "«За месяц число лидов с сайта выросло на 64%. При этом менеджеры перестали отвечать на вопросы “сколько стоит?” — этим занимается AI. Теперь они только закрывают тёплых клиентов. Окупилось за первую неделю.»",
        en: "\"In one month, the number of leads from the site grew by 64%. At the same time, managers stopped answering questions like “how much does it cost?” because AI handles that now. They focus only on closing warm leads. It paid off in the first week.\"",
      },
      author: {
        ru: "— Екатерина М., руководитель отдела продаж",
        en: "— Ekaterina M., Head of Sales",
      },
    },
    ctaTitle: {
      ru: "Начните собирать больше лидов уже сегодня",
      en: "Start collecting more leads today",
    },
    ctaDescription: {
      ru: "Протестируйте шаблон «Продажи» бесплатно. Настройка — 3 минуты, карта не нужна.",
      en: "Try the “Sales” template for free. Setup takes 3 minutes and no card is required.",
    },
  },
};

